export const getMeasures = (state) => (state.measures)
